/**
 * Composant de recherche pour le header
 * Gestion de l'affichage et des interactions de la barre de recherche expandable
 * Desktop : Barre qui s'étend sur toute la largeur avec fond bleu clair
 */

export class HeaderSearch {
  constructor() {
    this.searchToggle = document.querySelector('[data-search-toggle]');
    this.searchPanel = document.querySelector('[data-search-panel]');
    this.searchInput = this.searchPanel?.querySelector('input[type="search"]');

    this.init();
  }

  init() {
    if (!this.searchToggle || !this.searchPanel) {
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    // Toggle de la barre de recherche au clic sur la loupe
    this.searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleSearch();
    });

    // Fermer en cliquant en dehors
    document.addEventListener('click', (e) => {
      if (this.isSearchVisible() &&
          !this.searchToggle.contains(e.target) &&
          !this.searchPanel.contains(e.target)) {
        this.closeSearch();
      }
    });

    // Fermer avec Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isSearchVisible()) {
        this.closeSearch();
        this.searchToggle.focus();
      }
    });

    // Améliorer l'accessibilité
    this.searchToggle.setAttribute('aria-expanded', 'false');
    this.searchPanel.setAttribute('aria-hidden', 'true');
  }

  toggleSearch() {
    if (this.isSearchVisible()) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch() {
    this.searchPanel.classList.add('is-visible');
    this.searchToggle.setAttribute('aria-expanded', 'true');
    this.searchPanel.setAttribute('aria-hidden', 'false');

    // Fermer le mega-menu si ouvert
    const activeMegaMenu = document.querySelector('.primary-nav__menu-item--has-children.is-active');
    if (activeMegaMenu) {
      activeMegaMenu.classList.remove('is-active');
    }

    // Focus sur l'input avec un délai pour l'animation
    setTimeout(() => {
      this.searchInput?.focus();
    }, 150);
  }

  closeSearch() {
    this.searchPanel.classList.remove('is-visible');
    this.searchToggle.setAttribute('aria-expanded', 'false');
    this.searchPanel.setAttribute('aria-hidden', 'true');
  }

  isSearchVisible() {
    return this.searchPanel?.classList.contains('is-visible');
  }
}